module.exports = __webpack_public_path__ + "media/images/social_networks/instagram-17293cea6e5f0f66011ea850ddb5fe24.svg";